import APIPrices from '@/api/modules/prices';

const initialState = {
  clinicPrices: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    operationPrices: (state) => state.clinicPrices.filter((p) => p.entity === 'operations'),
    diagnosticPrices: (state) => state.clinicPrices.filter((p) => p.entity === 'diagnostics'),
  },
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    async getClinicPrices({ commit }, { clinicId, params }) {
      const { data } = await APIPrices.getClinicPrices(clinicId, params);
      commit('SET_DATA', { type: 'clinicPrices', data: data?.prices || [] });
    },
    upsert(_, prices) {
      return APIPrices.upsert(prices);
    },
  },
};
